import React from "react";
import CountryLayout from "@/components/CountryLayout";

export default function CountryNetherlands() {
  return <CountryLayout countryKey="netherlands" countryCode="nl" sourcePage="/countries/netherlands" />;
}
